import debounce from 'lodash.debounce';
import Swiper, { Pagination } from 'swiper';
import characterPopup from '../modules/characterPopup';
import BaseFilter from '../modules/filters/baseFilter';

export default class TeamSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.filter = this.root.querySelector('[data-filter-switcher]');
        this.isPostArray = false;

        if (this.filter) {
            this.isPostArray =
                this.filter.getAttribute('data-filter-posts-array') || false;
        }

        this.wrapper = this.root.querySelector('[data-team-section-list]');
        this.swiperEl = this.root.querySelector('[data-team-section-list]');
        this.loader = this.root.querySelector('[data-team-section-loader]');
        this.slider = null;
        this.currentCategory = null;
        this.filterInstance = null;

        this.loadTeam = debounce(this.getTeam, 500);

        Swiper.use([Pagination]);

        return true;
    }

    init() {
        this.initFilters();
        this.setSliderListener();
        this.onResize();
        this.setPopups();
    }

    initFilters() {
        if (!this.filter) return;
        this.filterInstance = new BaseFilter(this.filter, this.root);
        this.root.addEventListener('filter-switcher-change', event =>
            this.onFilterChange(event)
        );

        this.filterInstance.toggleClick(0);
    }

    setSliderListener() {
        this.resizeHandler = this.onResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
    }

    setPopups() {
        this.cards = this.root.querySelectorAll('.card-person');
        if (!this.cards) return;

        this.cards.forEach(item => {
            characterPopup(item);
        });
    }

    onResize(event) {
        const { innerWidth } = window;

        if (innerWidth > 992) {
            if (this.slider) {
                this.slider.destroy(true, true);
            }
        } else {
            this.initSwiper();
        }

        this.gridHandler();
    }

    initSwiper() {
        if (!this.swiperEl) return;

        this.slider = new Swiper(this.swiperEl, {
            slidesPerView: 1.25,
            spaceBetween: 24,
            pagination: {
                el: '.team-section__pagination',
                type: 'bullets',
                bulletClass: 'bottom-pagination__bullet',
                bulletActiveClass: 'active',
                clickable: true,
            },
        });
    }

    onFilterChange(event) {
        const { detail } = event;
        const { value } = detail;

        if (!this.isPostArray) {
            this.currentCategory = parseInt(value);
        } else {
            this.currentCategory = value;
        }

        this.loadTeam();
    }

    getTeam() {
        const formData = new FormData();
        formData.append('action', 'team_list');

        if (this.currentCategory && !this.isPostArray)
            formData.append('category', this.currentCategory);

        if (this.isPostArray) {
            formData.append('postsArray', this.currentCategory);
        }

        this.loader.classList.remove('d-none');

        jQuery.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { maxNumPages, html } = data;

                this.team = data.data;
                this.wrapper.innerHTML = html;

                if (this.slider) {
                    window.removeEventListener('resize', this.resizeHandler);
                    this.slider.destroy(true, true);
                    this.setSliderListener();
                    this.onResize();
                }

                this.gridHandler();
                this.setPopups();
            }.bind(this),
            error: function () {
                this.team = [];
            }.bind(this),
            complete: function () {
                this.loader.classList.add('d-none');
            }.bind(this),
        });
    }

    gridHandler() {
        const { innerWidth } = window;
        const cards = this.root.querySelectorAll('.card-person');
        if (!cards) return;

        const cardsArr = Array.from(cards);
        const gridCols = (innerWidth > 992) ? 4 : 1;
        const gridArr = new Array(Math.ceil(cardsArr.length / gridCols))
            .fill()
            .map(_ => cardsArr.splice(0, gridCols));

        gridArr.forEach((cardsItems) => {
            let maxTitleHeight = 0;

            cardsItems.forEach((item, index) => {
                const titleEl = item.querySelector('.card-person__name');
                const titleRect = titleEl.getBoundingClientRect();
                const { height } = titleRect;
    
                if (height > maxTitleHeight) maxTitleHeight = height;
            })
    
            cardsItems.forEach(item => {
                const contentEl = item.querySelector('.card-person__content-top');
                contentEl.style.height = `${maxTitleHeight}px`;
    
                if (innerWidth < 992) contentEl.style.height = `auto`;
            })
        })
    }
}
